import {useWholesaler} from 'context/wholesaler';
import {useMutation} from 'react-query';
import {useNavigate} from 'react-router-dom';
import {PostMarketPost} from 'services/farm/advertisement/add';

const usePostAd = () => {
  const {resetForm} = useWholesaler();
  const navigate = useNavigate();
  const {isLoading, mutate} = useMutation({
    mutationFn: (payload: IAddAdPost) => {
      return PostMarketPost(payload);
    },
    onSuccess: () => {
      resetForm();
      navigate('/wholesaler/home');
    },
  });

  return {isLoading, mutate};
};

export default usePostAd;
